import { useState, useEffect, useCallback } from 'react';
import { RefreshCw } from 'lucide-react';

const CHECK_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes

export default function UpdateBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [updating, setUpdating] = useState(false);

  const checkForUpdate = useCallback(async () => {
    try {
      const res = await fetch('/version.json?t=' + Date.now(), { cache: 'no-store' });
      if (!res.ok) return;
      const data = await res.json();
      const serverVersion = data.version;
      
      const stored = localStorage.getItem('app_version');
      if (!stored) {
        localStorage.setItem('app_version', serverVersion);
        return;
      }
      
      if (stored !== serverVersion && serverVersion !== '__BUILD_VERSION__') {
        setUpdateAvailable(true);
      }
    } catch (e) { /* offline or error, ignore */ }
  }, []);

  useEffect(() => {
    // First check after 10 seconds
    const initial = setTimeout(checkForUpdate, 10000);
    const interval = setInterval(checkForUpdate, CHECK_INTERVAL);
    return () => { clearTimeout(initial); clearInterval(interval); };
  }, [checkForUpdate]);

  const doUpdate = async () => {
    setUpdating(true);
    try {
      // 1. Tell SW to skip waiting (activate new version)
      if (navigator.serviceWorker?.controller) {
        const reg = await navigator.serviceWorker.getRegistration();
        if (reg?.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      }
      // 2. Clear all caches
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
      // 3. Update stored version
      try {
        const res = await fetch('/version.json?t=' + Date.now(), { cache: 'no-store' });
        const data = await res.json();
        localStorage.setItem('app_version', data.version);
      } catch (e) {}
      // 4. Hard reload
      window.location.reload(true);
    } catch (e) {
      window.location.reload(true);
    }
  };

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 animate-in slide-in-from-bottom duration-300" data-testid="update-banner">
      <button onClick={doUpdate} disabled={updating}
        className="w-full flex items-center justify-center gap-2 bg-gold text-black font-bold py-3 px-4 rounded-xl shadow-lg shadow-gold/20 hover:bg-gold/90 transition-all active:scale-95 disabled:opacity-70">
        <RefreshCw className={`h-4 w-4 ${updating ? 'animate-spin' : ''}`} />
        {updating ? 'Actualizando...' : 'Nueva version disponible - Pulsa para actualizar'}
      </button>
    </div>
  );
}
